import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { getFilteredReports } from "reduxSlices/reportIndexSlice"
import ReportRow from "./ReportRow"

const ReportList = ({
  editPath, editScheduledReportExportPath, newReportExportPath, newScheduledReportExportPath, reportType,
}) => {
  const reports = useSelector(getFilteredReports(reportType), isEqual)

  return (
    <div className="flex flex-col items-center justify-center">
      {
        reports.map((report) => (
          <ReportRow
            reportType={reportType}
            editPath={editPath}
            newReportExportPath={newReportExportPath}
            newScheduledReportExportPath={newScheduledReportExportPath}
            editScheduledReportExportPath={editScheduledReportExportPath}
            report={report}
            key={report.id}
          />
        ))
      }
    </div>
  )
}

ReportList.propTypes = {
  reportType: types.string.isRequired,
  editPath: types.func.isRequired,
  newReportExportPath: types.func.isRequired,
  newScheduledReportExportPath: types.func.isRequired,
  editScheduledReportExportPath: types.func.isRequired,
}

export default ReportList
